function view (path) {
  return () => import(/* webpackChunkName: 'ro-v1' */ '@/views/user/ro/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

function viewPurchaseOrders (path) {
  return view('purchase-orders/' + path)
}

function viewInterBranches (path) {
  return view('inter-branches/' + path)
}

const RRetailOfficer = [
  {
    path: '/retail/dashboard',
    component: view('Dashboard'),
    name: 'ro.dashboard',
    authorizedRole: 'user'
  }
]

const RROPurchaseOrders = [
  {
    path: '/retail/purchase-orders/requests/:requester?/:status?',
    component: viewPurchaseOrders('requests/Base'),
    name: 'ro.purchase-orders.requests',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Retail'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Requests',
          active: true
        }
      ]
    }
  },
  {
    path: '/retail/purchase-orders/receiving/:receiver?/:status?',
    component: viewPurchaseOrders('receiving/Base'),
    name: 'ro.purchase-orders.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Retail'
        },
        {
          text: 'Purchase Orders'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

const RROInterBranches = [
  {
    path: '/retail/inter-branches/transfers/:transfer?/:status?',
    component: viewInterBranches('transfers/Base'),
    name: 'ro.inter-branches.transfers',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Retail'
        },
        {
          text: 'Inter Branches'
        },
        {
          text: 'Transfers',
          active: true
        }
      ]
    }
  },
  {
    path: '/retail/inter-branches/posting/:poster?/:status?',
    component: viewInterBranches('posting/Base'),
    name: 'ro.inter-branches.posting',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Retail'
        },
        {
          text: 'Inter Branches'
        },
        {
          text: 'Posting',
          active: true
        }
      ]
    }
  },
  {
    path: '/retail/inter-branches/receiving/:receiver?/:status?',
    component: viewInterBranches('receiving/Base'),
    name: 'ro.inter-branches.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Retail'
        },
        {
          text: 'Inter Branches'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

export default RRetailOfficer.concat(
  RROPurchaseOrders,
  RROInterBranches
)
